import * as React from "react"
import {
  Spacer,
  StyledPanelBodySection,
  StyledPanelBoilerplate,
  useShowSuccessToast,
} from "gatsby-interface"
import { LogDrainIntegration } from "@modules/graphql/types"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { logDrainIntegration } from "@modules/locales/default.js"
import { logDrainVendorNames } from "../constants"
import { interpolateMessage } from "@modules/locales"
import { DataDogLogDrainWizard } from "@modules/logDrain/datadog/components/DataDogLogDrainWizard"

const integrationTitles: Record<string, string> = {
  DATADOG: logDrainIntegration.headers.dataDog,
}

export type LogDrainIntegrationModalProps = {
  siteId: string
  logDrain: LogDrainIntegration
  onClose: () => void
  onSuccess: () => void
}

export function LogDrainIntegrationModal({
  siteId,
  logDrain,
  onClose,
  onSuccess,
}: LogDrainIntegrationModalProps) {
  const [setError, errorAlert] = useTriggerErrorAlert()
  const showSuccessToast = useShowSuccessToast()

  const onError = (message: { message: string }) => setError(message)

  const vendorName = logDrainVendorNames[logDrain.logDrainProvider]
  return (
    <StyledPanelBoilerplate
      aria-label={interpolateMessage<"logDrainProviderName">(
        logDrainIntegration.headers.providerLogDrains,
        { logDrainProviderName: vendorName }
      )}
      isOpen={Boolean(logDrain)}
      onClose={onClose}
      header={interpolateMessage<"logDrainProviderName">(
        logDrainIntegration.headers.providerLogDrains,
        { logDrainProviderName: integrationTitles[logDrain.logDrainProvider] }
      )}
    >
      <StyledPanelBodySection>
        <DataDogLogDrainWizard
          logDrain={logDrain}
          onCancel={onClose}
          handleSuccess={({ successText }) => {
            onSuccess()
            onClose()
            showSuccessToast(successText)
          }}
          handleFailure={onError}
          siteId={siteId}
        />
        {errorAlert && (
          <React.Fragment>
            <Spacer size={5} />
            {errorAlert}
          </React.Fragment>
        )}
      </StyledPanelBodySection>
    </StyledPanelBoilerplate>
  )
}
